module.exports = __webpack_public_path__ + "static/jurica-koletic-7YVZYZeITc8-unsplash-a9517df07d213e866b7e29dd8ffd74b2.png";